<template>
  <div class="fx_content">

    <div class="fenxi_con">
      <h1 class="title">告警信息</h1>
      <div style="display:flex;">
        <div style="padding-left:30px;padding-top:20px">

          <p class="cishu">{{ zongshu }}<span>次</span></p>
          <p><img src="@/assets/bingtu.png"></p>

        </div>
        <div class="gjlist">
          <ul>
            <li v-for="(item, index) in listgaojing" :key="index" :class="'ys' + index"><span>{{
                filters(item.warningType)
            }} {{
    item.num
}}次 {{ towNumber(item.num / zongshu) * 100 }}%</span></li>
          </ul>
        </div>
      </div>
      <!-- <v-chart class="chart" :option="options" :autoresize="true" /> -->
    </div>
  </div>
</template>

<script>
import http from "@/api/http";
import { ref, onMounted, defineComponent, getCurrentInstance, watch } from "vue";
//import * as echarts from 'echarts';
export default defineComponent({
  name: "GaoJing",
  components: {},
  props: { gaojing: Object },
  setup(props) {





    var getname = ["系统故障", "系统告警", "电池告警", "电源告警"];

    var data = [];
    // var getbl = [40, 30, 18, 38];
    let radius1 = ["55%", "65%"];
    let radius2 = ["50%", "55%"];
    let center = ["30%", "35%"];

    var colorList = [
      "rgba(245,101,39,1)",
      "rgba(69,229,203,1)",
      "rgba(60,139,250,1)",
      "rgba(255,155,61,1)",
    ];

    var colorList1 = [
      "rgba(245,101,39,0.8)",
      "rgba(69,229,203,0.8)",
      "rgba(60,139,250,0.8)",
      "rgba(255,155,61,0.8)",
    ];
    const options = ref({
      tooltip: {
        trigger: "item",

        show: false,
      },

      title: {
        text: "告警",
        top: "27%",
        textAlign: "center",
        left: "30%",
        textStyle: {
          color: "#fff",
          fontSize: 22,
          fontWeight: "400",
        },
      },
      legend: {
        icon: "circle",
        itemGap: 20,
        itemWidth: 10,
        top: "0%",
        left: "55%",
        data: getname,
        width: 150,
        formatter: function (name) {
          for (var i = 0; i < data.length; i++) {
            if (name == data[i].name) {
              return (
                "{name|" +
                name +
                "}{value|\n" +
                data[i].value +
                "次}{rate|\n" +
                (data[i].value / data[i].total * 100).toFixed(0) +
                "}{cell2|%}"
              );
            }
          }
        },

        textStyle: {
          rich: {
            name: {
              fontSize: 13,

              fontWeight: 400,

              width: 50,

              height: 20,

              padding: [62, 0, 0, 0],

              color: "#ccced2",
            },

            value: {
              fontSize: 13,

              fontWeight: 400,

              width: 120,

              height: 20,

              //padding:[0,0,0,1],

              color: "#ccced2",
            },
            cell: {
              fontSize: 13,

              fontWeight: 400,

              width: 50,
              color: "#ccced2",
              height: 20,
            },

            rate: {
              fontSize: 13,

              fontWeight: 500,

              height: 35,

              width: 20,

              align: "left",

              color: "#ccced2",
            },
            cell2: {
              fontSize: 13,
              color: "#ccced2",
              fontWeight: 500,
            },
          },
        },
      },

      series: [
        {
          type: "pie",

          radius: radius1,

          center: center,

          itemStyle: {
            normal: {
              color: function (params) {
                return colorList[params.dataIndex];
              },
            },
          },

          label: {
            normal: {
              show: false,
            },
          },

          labelLine: {
            normal: {
              show: false,
            },
          },

          data: [],
        },
        {
          type: "pie",

          radius: radius2,

          center: center,

          itemStyle: {
            normal: {
              color: function (params) {
                return colorList1[params.dataIndex];
              },
            },
          },

          label: {
            normal: {
              show: false,
            },
          },

          labelLine: {
            normal: {
              show: false,
            },
          },

          data: [],
        },
      ],
    });

    const list = ref([])
    const listgaojing = ref([])
    const zongshu = ref(0)
    const provinceId = getCurrentInstance()?.appContext.config.globalProperties.$provinceId;
    const getData = () => {
      http.get("/base_station/province/" + provinceId).then((res) => {
        let total_num = 0;
        console.log('xx', res)
        res.data.warning_info.some((item, index) => {
          total_num += item.num
          zongshu.value += item.num
          options.value.series[0].data.push({ name: getname[index], value: item.num })

        });
        listgaojing.value = res.data.warning_info
        res.data.warning_info.some((item, index) => {

          data.push({ name: getname[index], value: item.num, total: total_num })
          options.value.series[1].data.push({ name: getname[index], value: item.num / total_num })
        });

        // props.gaojing.value.some((item, index) => {
        //   list.value[index] = item.num
        // })


      });
    };

    function towNumber(val) {
      return val.toFixed(2)
    }

    function filters(id) {
      let txt = "";
      switch (id) {
        case 'SYSTEM_FALT':
          txt = "系统故障";
          break;
        case 'SYSTEM_WARNING':
          txt = "系统告警";
          break;
        case 'BATTERY_WARNING':
          txt = "电池告警";
          break;
        case 'POWER_WARNING':
          txt = "电源告警";
          break;
      }
      return txt;
    }

    const eachlist = (data) => {
      data.some((item, index) => {
        list.value[index] = item.num
      })
    }

    watch(props, () => {
      eachlist(props.gaojing)
    }, {
      deep: true
    });

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData();
    });

    return {
      options, getData, list, zongshu, listgaojing, filters, towNumber
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fx_content {
  position: relative;
  /*相对位置*/
  height: calc(100% - 15px);
}

.cishu {
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  font-family: Arial, Helvetica, sans-serif;
}

.cishu span {
  font-size: 18px;
}

.fenxi {
  background: url("@/assets/conbg.png");
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  opacity: 0.5;
  position: absolute;
  top: 0;
  left: 0;
}

.fenxi_con {
  width: 100%;
  position: absolute;
  height: 100%;
}

.gjlist {
  color: #ccced3;
  margin-left: 35px;
  padding-top: 20px
}

.gjlist ul li {
  margin-bottom: 15px;
  list-style-type: disc;


}

.ys0 {
  content: ".";
  color: #3c8bfa
}

.ys1 {
  content: ".";
  color: #45e5cb
}

.ys2 {
  content: ".";
  color: #f5bd27
}

.ys3 {
  content: ".";
  color: #6a5df5
}

.gjlist ul li span {
  color: #ccced3;
}

.title {
  color: #fff;
  font-size: 15px;
  padding: 5px 30px 10px 40px;
  font-weight: bold;
  background: url("@/assets/biaoti.png") 10px 5px;
  background-repeat: no-repeat;
}
</style>
